import React from "react"; 
import { Card, CardContent, Typography, IconButton, Grid } from "@mui/material";
import FolderIcon from "@mui/icons-material/Folder";
import MoreVertIcon from "@mui/icons-material/MoreVert";

const FolderList = ({ folders, onFolderClick }) => {
  return (
    <Grid
      container
      spacing={1.5}
      sx={{ marginTop: "10px", ml: 0.5, maxWidth: "70%" }}
    >
      {folders.map((folder, index) => (
        <Grid item xs={12} sm={6} md={4} lg={4} key={index}>
          <Card
            variant="outlined"
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              padding: "8px",
              cursor: "pointer",
              position: "relative",
              minHeight: "160px",
              boxShadow: "0 1px 3px rgba(0, 0, 0, 0.2)",
              borderRadius: "6px",
              border: "1px solid grey",
              width: "95%", // Reduce width slightly
              margin: "5px auto", // Center the card
            }}
            onClick={() => onFolderClick(folder.path || folder.name)}
          >
            {/* More Options Button */}
            <IconButton sx={{ position: "absolute", top: 5, right: 5 }}>
              <MoreVertIcon fontSize="small" />
            </IconButton>

            {/* Folder Icon */}
            <FolderIcon
              sx={{ fontSize: "65px", color: "#6495ED", marginBottom: "5px" }}
            />

            {/* Folder Name */}
            <CardContent sx={{ padding: "5px 0 0 5px", textAlign: "left" }}>
              <Typography variant="body1" fontWeight="bold">
                {folder.name}
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
};

export default FolderList;
